<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_text">
                        <span>Publication Readiness Checks</span>
                        <h1>Verificações de prontidão para publicação</h1>
                        <p>Com as verificações de prontidão de publicação da Trinka, você pode avaliar seu documento em mais
                            de 20 pontos de verificação, variando para Seleção de Revista para Compliance Ético, para aumentar
                            suas chances de ser publicado.</p>
                        <a href="https://cloud.trinka.ai/signup?_rg=PT" id="autoEditGetStart" target="_blank">Fale Conosco</a>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="toolbox_img_content publication_checks_icons publication_checks_section">
                        <ul>
                            <li>
                                <div class="checks_icons">
                                    <img src="../../../assets/images/JournalScope.svg" alt="journal scope">
                                </div>
                                <h3>Verificação Do Escopo Do Periódico</h3>
                                <span>2 Checks</span>
                            </li>

                            <li>
                                <div class="checks_icons">
                                    <img src="../../../assets/images/TechnicalCompliance.svg" alt="Technical Compliance">
                                </div>
                                <h3>Conformidade técnica</h3>
                                <span>3 Checks</span>
                            </li>

                            <li>
                                <div class="checks_icons">
                                    <img src="../../../assets/images/EthicalCompliance.svg" alt="Ethical Compliance">
                                </div>
                                <h3>Conformidade ética</h3>
                                <span>5 Checks</span>
                            </li>

                            <li>
                                <div class="checks_icons">
                                    <img src="../../../assets/images/AuthorshipDetails.svg" alt="Authorship Details">
                                </div>
                                <h3>Detalhe da autoria</h3>
                                <span>4 Checks</span>
                            </li>
                            <li>
                                <div class="checks_icons">
                                    <img src="../../../assets/images/ReferenceDetails.svg" alt="Reference Details">
                                </div>
                                <h3>Detalhe da referência</h3>
                                <span>1 Check</span>
                            </li>

                            <li>
                                <div class="checks_icons">
                                    <img src="../../../assets/images/FirgureTable.svg" alt="Firgure Table">
                                </div>
                                <h3>Figuras e Tabelas</h3>
                                <span>2 Checks</span>
                            </li>

                            <li>
                                <div class="checks_icons">
                                    <img src="../../../assets/images/ClinicalTrials.svg" alt="Clinical Trials">
                                </div>
                                <h3>Informação do ensaio clínico</h3>
                                <span>1 Check</span>
                            </li>

                            <li>
                                <div class="checks_icons">
                                    <img src="../../../assets/images/KeywordsAndSummary.svg" alt="Keywords Summary">
                                </div>
                                <h3>Palavras-chave & Resumo</h3>
                                <span>2 Checks</span>
                            </li>
                            <i></i>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="SectionHowItWrok" #viewVideo>
        <div class="container">
            <div class="row">
                <div class="col-xl-6">
                    <div class="ImgSectionHowItWrok">
                        <a href="" data-toggle="modal" data-target="#wordPluginPopup" id="VewiVideoSection">
                            <img src=".././../../assets/images/PublicationCheckThumbnail.png" alt="Publication Check" class="img-fluid eposter-img">
                        </a>
                    </div>
                </div>
                <div class="col-xl-6">
                    <div class="contentSectionHowItWrok">
                        <h2>Veja como funciona</h2>
                        <div class="HeadingSubLine"></div>
                        <p style="margin-bottom: 10px;">Saiba como você pode usar as mais de 20 verificações de Prontidão para Publicação e ser publicado
                            mais rapidamente assistindo a esse pequeno vídeo passo-a-passo. </p>
                        <p style="margin-bottom: 10px;">É um tutorial passo a passo detalhado para ajudá-lo a usar Trinka ao máximo. Tem mais perguntas?
                            Navegue pelas nossas perguntas frequentes
                            <a style="color: #0000ff;" (click)="scroll(target)" class="link">aqui</a>.</p>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <div class="cloud_key_features">
        <div class="container">
            <div class="row">
                <div class="col-12-sm">
                    <div class="key_features_heading">
                        <h2>Principais características da verificação de prontidão de publicação</h2>
                        <div class="HeadingSubLine"></div>
                        <p>Com a Verificação de Prontidão para Publicação da Trinka, você pode avaliar seu documento em mais
                            de 20 verificações de prontidão para publicação e fazer correções para aumentar suas chances
                            de ser publicado.</p>
                    </div>
                </div>
            </div>
            <div class="row">

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <div class="publication_inner_icons">
                            <img src="../../../assets/images/JournalScope.svg" alt="Journal Scope">
                        </div>
                        <h3>Verificação Do Escopo Do Periódico</h3>
                        <p>Ajuda a evitar a rejeição verificando se o manuscrito corresponde ao escopo do diário de destino
                            e sugere diários correspondentes adicionais.</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <div class="publication_inner_icons">
                            <img src="../../../assets/images/TechnicalCompliance.svg" alt="Technical Compliance">
                        </div>
                        <h3>Conformidade técnica</h3>
                        <p>A Trinka verifica vários requisitos de publicação padrão, como resumo, contagem de palavras e cabeçalhos
                            de seção de manuscritos, para que você esteja sempre assegurado de atender a todos os requisitos.</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <div class="publication_inner_icons">
                            <img src="../../../assets/images/EthicalCompliance.svg" alt="Ethical Compliance">
                        </div>
                        <h3>Conformidade ética</h3>
                        <p>Garante que você tenha feito todas as declarações obrigatórias, como consentimento informado, aprovação
                            ética, divulgações financeiras e conflito de interesses, para uma triagem suave do balcão editorial.</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards commingSoonTag">
                        <div class="publication_inner_icons">
                            <img src="../../../assets/images/AuthorshipDetails.svg" alt="Authorship Details">
                        </div>
                         <h3>Detalhe da autoria</h3>
                        <p>Verifique se há detalhes da autoria, como nome do autor, afiliação, correspondência e avaliações
                            de contribuição, que são exigidos pela maioria dos periódicos.</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards commingSoonTag">
                        <div class="publication_inner_icons">
                            <img src="../../../assets/images/ReferenceDetails.svg" alt="Reference Details" style="width: 30px; height: 38px;">
                        </div>
                        <h3>Detalhe da referência</h3>
                        <p>A Trinka verifica suas referências e alerta você para o uso de referências obsoletas.</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards commingSoonTag">
                        <div class="publication_inner_icons">
                            <img src="../../../assets/images/FirgureTable.svg" alt="Firgure Table">
                        </div>
                        <h3>Figuras e tabelas</h3>
                        <p>A Trinka verifica todas as suas legendas de figura e tabela, bem como suas citações para garantir
                            que você atenda a todos os requisitos de envio.</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards commingSoonTag">
                        <div class="publication_inner_icons">
                            <img src="../../../assets/images/ClinicalTrials.svg" alt="Clinical Trials" style="width: 29px; height: 35px;">
                        </div>
                        <h3>Informação do ensaio clínico</h3>
                        <p>A Trinka verifica se você mencionou qualquer identificação de ensaios clínicos e obtém informações
                            sobre o ensaio para que você esteja sempre seguro de fornecer os detalhes certos.</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards commingSoonTag">
                        <div class="publication_inner_icons">
                            <img src="../../../assets/images/KeywordsAndSummary.svg" alt="Keywords Summary">
                        </div>
                        <h3>Palavras-chave & resumo</h3>
                        <p>A IA de ponta da Trinka gera um resumo holístico e representativo do seu texto, destacando os tópicos
                            e conceitos importantes do seu artigo. Também sugere possíveis palavras-chave para o seu manuscrito.</p>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <div class="cloud_key_features" style="padding: 0;margin: 0 0 60px 0;">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="key_features_heading">
                        <h2>Ver um exemplo de relatório</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
                <!-- <div class="col-sm-2"></div> -->
                <div class="col-sm-12">
                    <div class="viewSampleReportImg">
                        <img src="../../../assets/images/PublicationReportImg.png" alt="reports">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="use_trinka_other_app accomplishBrilliantWrap">
        <div class="container">
            <div class="accomplishBrilliantSection">
                <h2>Verifique o seu manuscrito para prontidão para publicação</h2>
                <a href="https://cloud.trinka.ai/signup?_rg=PT" target="_blank">Iniciar</a>
            </div>
        </div>
    </div>

    <div class="allAboutTrinkaCredit">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="aboutTrinkaCreditHeading">
                        <h2>As verificações de prontidão para publicação usam créditos</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                    <div class="creditSectionFeature">
                        <div class="featurePointsCredits">
                            <span>
                                <img src="../../../assets/images/lightbulb.png" alt="icon">
                            </span>
                            <p>Cada geração de relatório usa 1 crédito. Use créditos gratuitos e compre mais conforme necessário.</p>
                        </div>
                        <div class="othersPointsForCredits">
                            <p style="margin-bottom: 10px;">Os créditos são como tokens que permitem que você use vários recursos do Trinka conforme necessário.</p>
                            <p>Usuários Premium ganham 10 e usuários Básicos ganham 4 créditos grátis todo mês. Para saber mais
                                clique
                                <a [routerLink]="['/features/credits']">aqui</a>.</p>
                        </div>
                    </div>
                </div>
                <!-- <div class="col-lg-4 col-md-6">
                        <div class="CreditBoxTrinka">
                            <div class="card_overlay"></div>
                            <div class="CreditBoxTrinkaHeader">
                                <h3>Free Credits Available</h3>
                            </div>
                            <p>Basic users get 2 and Premium users get 5 free credits every month. Unused free credits expire at month end.</p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <div class="CreditBoxTrinka">
                            <div class="card_overlay"></div>
                            <div class="CreditBoxTrinkaHeader">
                                <h3>Credits Consumed</h3>
                            </div>
                            <p>Publication Readiness Checks uses 1 credit for each check.</p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <div class="CreditBoxTrinka">
                            <div class="card_overlay"></div>
                            <div class="CreditBoxTrinkaHeader">
                                <h3>Buy More Credits</h3>
                            </div>
                            <p>If you need additional credits, you can purchase them whenever needed. Purchased Credits do not expire.</p>
                        </div>
                    </div> -->
            </div>
        </div>
    </div>

    <div class="pricingQuestionAnwser" #target>
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="pricingHeadingQuestion">
                        <h2>Perguntas Feitas Frequentemente</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
                <div class="col-lg-10">
                    <div class="pricingQuestionsList">
                        <div class="accordion" id="faq">
                            <div class="card">
                                <div class="card-header" id="QuestionOne">
                                    <a href="#" class="btn btn-header-link" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                        Quantos créditos as Verificações de Prontidão para Publicação usam?</a>
                                </div>

                                <div id="QuestionOneContent" class="collapse show" aria-labelledby="QuestionOne" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Toda vez que você executa as verificações de prontidão para publicação, 1 crédito
                                            é consumido.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                        aria-controls="QuestionTwoContent">
                                        Posso baixar o relatório de Prontidão para Publicação? </a>
                                </div>

                                <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Atualmente, você não pode baixar o relatório de Prontidão para Publicação. No entanto,
                                            o seu relatório está sempre disponível no Trinka Cloud. Você também receberá
                                            um link para cada relatório em seu ID de e-mail registrado. </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                        aria-controls="QuestionThreeContent">
                                        Terei o recurso Verificações de Prontidão para Publicação no plano Básico do Trinka?
                                    </a>
                                </div>

                                <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Sim. Este recurso usa créditos. Os usuários da assinatura Basic recebem 4 créditos
                                            gratuitos todos os meses que podem ser usados para obter o relatório de Prontidão
                                            para Publicação. </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                        aria-controls="QuestionFourContent">
                                        Como posso usar o relatório de Prontidão para Publicação?
                                    </a>
                                </div>

                                <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Você pode usar o relatório de Prontidão para Publicação como uma lista de verificação
                                            para comparar facilmente com os requisitos do seu periódico alvo e avaliar facilmente
                                            a prontidão do seu artigo. Preparamos um
                                            <a style="color: #0000ff;" (click)="scroll(viewVideo)" class="link">vídeo</a> para ajudar você a entender também o relatório.</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
            </div>
        </div>
    </div>
    <div class="use_trinka_other_app">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="use_trinka_content">
                        <div class="use_trinka_heading">
                            <div class="howItWorkHeading lineWhiteColor">
                                <h2>Use o Trinka em outros aplicativos</h2>
                                <div class="HeadingSubLine"></div>
                            </div>
                        </div>
                        <div class="others_app_name">
                            <ul>
                                <li>
                                    <a href="https://www.trinka.ai/pt/trinkacloud">
                                        <div class="app_name_content" routerLink="/trinkacloud">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Other_apps_TrinkaCloud.svg" alt="trinka cloud">
                                            <h3>Trinka Cloud</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.trinka.ai/pt/wordplugin">
                                        <div class="app_name_content" routerLink="">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Others_App_MSWord.svg" alt="ms word">
                                            <h3>MS Word Plug-in</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.trinka.ai/pt/browser-plugin">
                                        <div class="app_name_content" routerLink="/browser-plugin">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/other_Apps_browser.svg" alt="bowser plugin">
                                            <h3>Plugins do navegador</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.trinka.ai/pt/enterprise">
                                        <div class="app_name_content" style="padding: 0px;" routerLink="/enterprise">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Other_Apps_enterprise.svg" alt="enterprise">
                                            <h3 style="margin: 0 0 -2px 0;">Empresas</h3>
                                            <span style="font-size: 12px; color: #000; position: relative;">(API, JS & On-Premise)
                                            </span>
                                        </div>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="wordPluginPopup" tabindex="-1" role="dialog" aria-labelledby="wordPluginLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>

                <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/c8yyiW2tEjE"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                <!-- <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/z-TVcRwVp3A"
                        title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe> -->
            </div>
        </div>
    </div>
</div>